export const PACKAGE_NAME = 'jiraIssueTableHierarchyToggle';
export const TEAM_NAME = 'empanada';
